import "./style.scss";

function insightClassName(tone, className) {
    return ["ai-insight", tone && `ai-insight--${tone}`, className]
        .filter(Boolean)
        .join(" ");
}

export default function AiInsightBody({
    headline,
    summary,
    highlights,
    metaItems,
    tone,
    className,
    children,
}) {
    const items = Array.isArray(metaItems) ? metaItems.filter(Boolean) : [];
    const points = Array.isArray(highlights)
        ? highlights.filter((item) => String(item || "").trim())
        : [];

    return (
        <div className={insightClassName(tone, className)}>
            {items.length > 0 && (
                <div className="ai-insight__meta">
                    {items.map((item) => (
                        <p key={item.id}>{item.text}</p>
                    ))}
                </div>
            )}
            {headline ? (
                <p className="ai-insight__headline">{headline}</p>
            ) : null}
            {summary ? <p className="ai-insight__summary">{summary}</p> : null}
            {points.length > 0 ? (
                <ul className="ai-insight__highlights">
                    {points.map((item, index) => (
                        <li key={`${index}-${item}`}>{item}</li>
                    ))}
                </ul>
            ) : null}
            {children}
        </div>
    );
}
